export const DEVICE_TYPE_CODE_NARROW = 'wph';
export const DEVICE_TYPE_CODE_WIDE = 'wde';
